import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-slate-950 py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-119" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-120" data-mp="1dxjhpcxccxci">
        <SectionHeading id="modules-title" data-id="element-121" data-mp="1duni7k5ui0ly">The {totalVolumes} <span className="text-yellow-400" data-id="element-122" data-mp="2bj7fa15j9lpm">Complete Volumes</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-123" data-mp="26km9znbfcbub">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-slate-600/70 bg-blue-950 p-6 shadow-lg shadow-black/30" data-id="element-124" data-mp="21nvy7c6nk2ep" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-125" data-mp="1ns8vy5ocwru0">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-yellow-400/40 bg-slate-950 text-yellow-400" data-id="element-126" data-mp="18w15woq9ow6t">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-127" data-mp="104r306tcvnpg" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-amber-400" data-id="element-128" data-mp="102wiuupwrzmf">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-xl font-extrabold uppercase leading-tight text-stone-50" data-id="element-129" data-mp="q7coicqzt8zs">{module.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-300" data-id="element-130" data-mp="v6ftjx6z3f7r">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}